exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".herd-card[data-v-7eeff45c]{color:#fff;padding:5px 10px;margin:5px 10px;background:#414f51;border:1px solid #30383a;border-radius:5px;-webkit-transition-duration:.5s;transition-duration:.5s}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/SystemHerdWeightCard.vue"],"names":[],"mappings":"AACA,4BACI,WAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,mBAAoB,AACpB,yBAA0B,AAC1B,kBAAmB,AACnB,gCAAkC,AAC1B,uBAA0B,CACrC","file":"SystemHerdWeightCard.vue","sourcesContent":["\n.herd-card[data-v-7eeff45c] {\n    color: white;\n    padding: 5px 10px;\n    margin: 5px 10px;\n    background: #414F51;\n    border: 1px solid #30383a;\n    border-radius: 5px;\n    -webkit-transition-duration: 0.5s;\n            transition-duration: 0.5s;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7eeff45c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Systems/SystemHerdWeightCard.vue
// module id = 2058
// module chunks = 25